import {
  AADetectionResults,
  AdBlockerType,
  PageViewEventType,
  SoftwallRecoveredType,
} from "../types";
import { sendEvent, isSessionRecovered } from "../utils";
import { log } from "../utils/logs";

export const onPageView = (
  rlEnabled: boolean,
  recovered: SoftwallRecoveredType,
  aaDetectionResults: AADetectionResults,
  detectedExtension: AdBlockerType,
  consentMessageShown: boolean,
  attributionWindow: number,
) => {
  if (!window.__bt_intrnl.rlPVSent) {
    window.__bt_intrnl.rlPVSent = true;
    let event: PageViewEventType = "non_ab_pageview";
    if (aaDetectionResults.ab) {
      event = aaDetectionResults.acceptable ? "aa_pageview" : "ab_pageview";
    }

    const { isActive } = isSessionRecovered(recovered, attributionWindow);

    // As we always load RL script from tag
    // we should send PV event only if RL is enabled
    // OR if RL is already disabled, but user was recovered and attribution window has not expired yet
    if (rlEnabled || isActive) {
      sendEvent({
        event,
        detectedExtension,
        consentMessageShown,
      }).catch((error) => {
        log(
          "rlink.onPageViewError",
          {
            version: __SCRIPT_VERSION__,
            aaResults: window.__bt_intrnl.aaDetectionResults,
            error: error instanceof Error ? error.message : error,
          },
          { severity: 4 },
        );
      });
    }
  }
};
